export const CALCULATION_STEP_DOCUMENTS = {
    'CALCULATION_STEP.DOCUMENTS.TITLE': 'ANEXE: Documente suport',
    'CALCULATION_STEP.DOCUMENTS.BONUS_TITLE': 'Documente asociate bonificației',
    'CALCULATION_STEP.DOCUMENTS.UPLOAD.TITLE': 'Încarcă documente suport',
    'CALCULATION_STEP.DOCUMENTS.UPLOAD.DESCRIPTION': 'Trage și eliberează aici documentele sau click aici pentru a căuta fișierele',
    'CALCULATION_STEP.DOCUMENTS.COLUMN.NAME': 'Denumire document',
    'CALCULATION_STEP.DOCUMENTS.COLUMN.ASSOCIATION_DATE': 'Dată asociere',
    'CALCULATION_STEP.DOCUMENTS.COLUMN.ACTIONS': 'Acțiuni',
    'CALCULATION_STEP.DOCUMENTS.REUSE_DOCUMENTS.MODAL.TITLE': 'Reutilizează documente suport',
    'CALCULATION_STEP.DOCUMENTS.REUSE_DOCUMENTS.MODAL.LINK_DOCUMENTS': 'Asociază documente'
};
